import {
  isManifestDocumentReviewed,
  ManifestDocumentReviewState,
} from "encamp-shared/src/waste/manifestSourcePriority";

import { useBoundedRefetch } from "./useBoundedRefetch";

/**
 * Where an unreviewed document pillar stands: still waiting on a reviewer, or
 * reviewed but not yet counted by the manifest — refetching until it is.
 *
 * A confirmed review lands on the document at once, but the manifest counts it
 * only once process-manifests refreshes `documentSourceReviewed`. Read off the
 * data rather than the review dialog's completion, so a review saved from any
 * surface — the drawer, a `?review=` link, another tab — settles here too.
 */
export function useDocumentReviewProgress({
  documentDataUnreviewed,
  sourceDocument,
  refetch,
}: {
  /** The manifest has a document pillar that isn't among its sources. */
  documentDataUnreviewed: boolean;
  sourceDocument: { documentMetadata?: ManifestDocumentReviewState | null } | null | undefined;
  refetch: () => void;
}): { pendingReview: boolean; awaitingRecompute: boolean } {
  const awaitingRecompute =
    documentDataUnreviewed && isManifestDocumentReviewed(sourceDocument?.documentMetadata);
  useBoundedRefetch(awaitingRecompute, refetch);
  return { pendingReview: documentDataUnreviewed && !awaitingRecompute, awaitingRecompute };
}
